import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';
import { MenuService } from '../../menu.service';
import { MenuEntry } from 'src/app/shared/entrys/menu.entry';
import { OpcionesMenuEntry } from 'src/app/shared/entrys/opciones-menu.entry';
import { MatSidenav } from '@angular/material/sidenav';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { MenuTree } from 'src/app/shared/models/menu-tree.model';
import { NestedTreeControl } from '@angular/cdk/tree';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { NotificacionesService } from 'src/app/components/core/containers/bandeja-principal/prestador/notificaciones/notificaciones.service';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-menu-template3',
	templateUrl: './menu-template3.component.html',
	styleUrls: ['./menu-template3.component.scss']
})
export class MenuTemplate3Component implements OnInit {
  public year : number = Date.now();
	public esUsuarioPrestador:boolean = false;

  @ViewChild('sidenav', { static: false }) sidenav: MatSidenav;
	nestedTreeControl: NestedTreeControl<MenuTree>;
	nestedDataSource: MatTreeNestedDataSource<MenuTree>;

	reason = '';
	sideActive: boolean;
	userLogin: boolean;
	user_name: string;
	opcionesMenu: OpcionesMenuEntry;
	menuHorizontal: Array<MenuEntry>;
	close(reason: string) {
		this.reason = reason;
		this.sidenav.close();
	}

	public notificationsCount:number = 0;

	constructor(private authService: AuthService,
		private router: Router,
		private menuService: MenuService,
		private _notificacionesService:NotificacionesService) 
	{
		this.nestedTreeControl = new NestedTreeControl<MenuTree>(this._getChildren);
		this.nestedDataSource = new MatTreeNestedDataSource();
		this.sideActive = true;
		this.userLogin = authService.isToken();
		this.opcionesMenu = this.menuService.getRoles();
		
		_notificacionesService.onNotificationChanged = new Subject<any>();
		_notificacionesService.onNotificationChanged
		.subscribe(() => {
			this.getNotificationsCountWithoutRead();
		})
	}

	navegacion(url: string) {
		this.router.navigate([url]);
	}
	hasNestedChild = (_: number, nodeData: MenuTree) => !nodeData.ruta_url;

	private _getChildren = (node: MenuTree) => node.hijos;

	ngOnInit() {
		this.user_name = this.authService.getUserNameToken();
		this.nestedDataSource.data = this.menuService.buildFileTree(this.opcionesMenu.vertical, 0);
		this.menuHorizontal = this.opcionesMenu.horizontal;
		const tipoUsuario = this.authService.getTipoUser();
		this.esUsuarioPrestador = tipoUsuario == RolesUsuario.Prestador;
		this.getNotificationsCountWithoutRead();
	}

	onClose() {
		this.authService.logout();
		this.router.navigate(['/home']);
	}


	onRegresar() {
		if (this.menuService.getRoles().horizontal && this.menuService.getRoles().horizontal.length > 0) {
			this.router.navigate([this.menuService.getRoles().horizontal[0].ruta_url]);
		} else {
			this.router.navigate(['/perfil']);
		}
	}

  onOLClick() {
		window.open('http://www.confecamaras.org.co');
	}

	private getNotificationsCountWithoutRead(): void {
		if(!this.esUsuarioPrestador) return;
		this._notificacionesService.get(this.user_name)
		.subscribe(response => {
			if(!response.result) return;
			this.notificationsCount = response.data;
		})
	}
}
